import React from 'react';
import { Link } from 'react-router-dom';

export default function ModernFooter() {
  return (
    <footer className="bg-[var(--color-text-primary)] text-white">
      {/* Main Footer */}
      <div className="mx-auto max-w-[var(--container-max)] px-4 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-12">
          {/* About */}
          <div>
            <div className="text-2xl font-bold font-[var(--font-serif)] mb-4">
              XL <span className="text-[var(--color-accent)]">bútor</span>
            </div>
            <p className="text-white/70 text-sm leading-relaxed">
              Egyedi bútorok készítése 1989 óta. 3D tervezés, precíz kivitelezés, saját műhelyben – minden egy helyen.
            </p>
          </div>

          {/* Navigation */}
          <div>
            <h3 className="font-semibold text-lg mb-4">Navigáció</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/" className="text-white/70 hover:text-[var(--color-accent)] transition-colors">
                  Főoldal
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-white/70 hover:text-[var(--color-accent)] transition-colors">
                  Rólunk
                </Link>
              </li>
              <li>
                <Link to="/works" className="text-white/70 hover:text-[var(--color-accent)] transition-colors">
                  Munkáink
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-white/70 hover:text-[var(--color-accent)] transition-colors">
                  Kapcsolat
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="font-semibold text-lg mb-4">Kapcsolat</h3>
            <ul className="space-y-3 text-sm">
              <li>
                <a href="tel:06704179210" className="text-white/70 hover:text-[var(--color-accent)] transition-colors flex items-center gap-2">
                  <span>📞</span>
                  <span>06 (70) 417 9210</span>
                </a>
              </li>
              <li>
                <a href="mailto:xlbutorbolt@gmail.com" className="text-white/70 hover:text-[var(--color-accent)] transition-colors flex items-center gap-2">
                  <span>✉️</span>
                  <span>xlbutorbolt@gmail.com</span>
                </a>
              </li>
              <li className="text-white/70 flex items-start gap-2">
                <span>📍</span>
                <span>Kisvárda, Attila u. 61<br />4600</span>
              </li>
              <li>
                <a href="https://www.facebook.com/goncz.sandor.7" target="_blank" rel="noopener noreferrer" className="text-white/70 hover:text-[var(--color-accent)] transition-colors flex items-center gap-2">
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
                  </svg>
                  <span>Facebook</span>
                </a>
              </li>
            </ul>
          </div>

          {/* Opening Hours */}
          <div>
            <h3 className="font-semibold text-lg mb-4">Nyitvatartás</h3>
            <ul className="space-y-2 text-sm text-white/70">
              <li className="flex justify-between">
                <span>Hétfő - Péntek:</span>
                <span className="font-semibold">9:00 - 17:00</span>
              </li>
              <li className="flex justify-between">
                <span>Szombat:</span>
                <span className="font-semibold">9:00 - 13:00</span>
              </li>
              <li className="flex justify-between">
                <span>Vasárnap:</span>
                <span className="font-semibold">Zárva</span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-white/10">
        <div className="mx-auto max-w-[var(--container-max)] px-4 py-6">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4 text-sm text-white/60">
            <div>
              © {new Date().getFullYear()} XL bútor. Minden jog fenntartva.
            </div>
            <div className="flex items-center gap-6">
              <Link to="/impresszum" className="hover:text-[var(--color-accent)] transition-colors">
                Impresszum
              </Link>
              <Link to="/aszf" className="hover:text-[var(--color-accent)] transition-colors">
                ÁSZF
              </Link>
              <Link to="/adatkezelesi-tajekoztato" className="hover:text-[var(--color-accent)] transition-colors">
                Adatkezelési tájékoztató
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}

